import type { UIStringsOverride } from "../i18n-ui.ts";

/** Hungarian (hu) UI strings. */
export const hu: UIStringsOverride = {
  actions: {
    addToCursor: "Hozzáadás a Cursorhoz",
    addToVscode: "Hozzáadás a VS Code-hoz",
    askAI: "Kérdezd az AI-t erről az oldalról",
    connectMcp: "Kapcsolódás az MCP-hez",
    copied: "Másolva!",
    copyClaudeCode: "Claude Code parancs másolása",
    copyCode: "Kód másolása",
    copyCodex: "Codex parancs másolása",
    copyMarkdown: "Másolás Markdownként",
    copyServerUrl: "Szerver URL másolása",
    edit: "Szerkesztés a GitHubon",
    export: "Exportálás",
    exportEpub: "Exportálás EPUB-ba",
    exportPdf: "Exportálás PDF-be",
    generating: "Generálás…",
    openIn: "Megnyitás itt: {name}",
    openInChat: "Megnyitás a csevegésben",
    scrollToTop: "Vissza a tetejére",
  },
  ask: {
    ai: "AI",
    clear: "Beszélgetés törlése",
    close: "Bezárás",
    copy: "Beszélgetés másolása",
    empty: "Tegyél fel kérdést a dokumentációval kapcsolatban.",
    error: "Sajnáljuk, valami hiba történt.",
    label: "Tegyél fel egy kérdést",
    placeholder: "Tegyél fel egy kérdést…",
    send: "Küldés",
    tip: "Tipp: A csevegést ezzel nyithatod meg és zárhatod be:",
    title: "Kérdezd az AI-t",
    you: "Te",
  },
  banner: { dismiss: "Közlemény bezárása" },
  changelog: {
    description: "Termékfrissítések és kiadási megjegyzések.",
    showReleases: "{version} kiadások megjelenítése",
    title: "Változásnapló",
  },
  content: { diagramError: "Ezt a diagramot nem sikerült megjeleníteni." },
  feedback: {
    no: "Nem",
    question: "Hasznos volt ez az oldal?",
    thanks: "Köszönjük a visszajelzésed!",
    yes: "Igen",
  },
  languageSwitcher: { label: "Nyelv", untranslated: "Nincs lefordítva" },
  nav: {
    back: "Vissza",
    breadcrumb: "Morzsamenü",
    closeNavigation: "Navigáció bezárása",
    deprecated: "elavult",
    featured: "Kiemelt",
    githubRepository: "GitHub-tároló",
    navigation: "Navigáció",
    primary: "Elsődleges",
    sections: "Szakaszok",
    toggleNavigation: "Navigáció ki-/bekapcsolása",
    toggleTheme: "Színtéma váltása",
  },
  notFound: {
    description: "Nem találtuk a keresett oldalt.",
    home: "Vissza a kezdőlapra",
    title: "Az oldal nem található",
  },
  page: {
    lastUpdated: "Utoljára frissítve",
    next: "Következő",
    pagination: "Lapozás",
    previous: "Előző",
    skipToContent: "Ugrás a tartalomra",
  },
  search: {
    all: "Összes",
    allLanguages: "Összes nyelv",
    askAi: "Kérdezd az AI-t",
    askAiHint: "Kapj azonnali választ az AI-tól",
    button: "Keresés",
    devOnly: "A keresés az éles buildben érhető el.",
    error: "Hiba történt. Próbáld újra.",
    label: "Keresés a dokumentációban",
    navigate: "navigálás",
    noResults: "Nincs találat.",
    open: "megnyitás",
    placeholder: "Keresés a dokumentációban…",
    popular: "Népszerű",
    preview: "előnézet",
    results: "Találatok",
  },
  toc: { title: "Ezen az oldalon" },
};
